import TelephoneCell from "application/components/TelephoneCell";
import DefaultCell from "application/components/DefaultCell";
import CTLBooleanCell from "application/components/CTLBooleanCell";
import IncommingOutgoingCallCell from "application/components/InOutCallCell";

const getNewColumns = (onCall) => {
  return [
    {
      Header: "Direction",
      accessor: "callDirection",
      displayInList: true,
      allowFilter: true,
      dataType: "long",
      Cell: ({ value, row }) => <IncommingOutgoingCallCell value={value} row={row} />,
    },
    {
      Header: "Dialed From",
      accessor: "ucNumber",
      displayInList: true,
      allowFilter: true,
      dataType: "long",
      Cell: ({ value }) => <TelephoneCell value={value} onCall={onCall} />,
    },
    {
      Header: "Dialed To",
      accessor: "ucDialedTo",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <TelephoneCell value={value} onCall={onCall}/>,
    },
    {
      Header: "Received On",
      accessor: "callReceivedOn",
      displayInList: true,
      allowFilter: false,
      dataType: "date",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "UserName",
      accessor: "ucUserId",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} onCall={onCall} />,
    },

    {
      Header: "Duration",
      accessor: "callDuration",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} onCall={onCall} />,
    },
    {
      Header: "Missed",
      accessor: "isMissed",
      displayInList: false,
      allowFilter: false,
      dataType: "long",
      Cell: ({ value }) => <CTLBooleanCell value={value} />,
    },
  ];
};

export { getNewColumns };
